import apiClient from './api';

// Serviço para autenticação
export const authService = {
  // Login do usuário
  login(credentials) {
    return apiClient.post('/auth/token', credentials);
  },
  
  // Verificar token atual
  verifyToken() {
    return apiClient.get('/auth/verify');
  }
};

// Serviço para gerenciamento de pipelines
export const pipelineService = {
  // Obter todos os pipelines
  getAll() {
    return apiClient.get('/pipelines');
  },
  
  // Obter pipeline por ID
  getById(id) {
    return apiClient.get(`/pipelines/${id}`);
  },
  
  // Criar novo pipeline
  create(pipeline) {
    return apiClient.post('/pipelines', pipeline);
  },
  
  // Atualizar pipeline existente
  update(id, pipeline) {
    return apiClient.put(`/pipelines/${id}`, pipeline);
  },
  
  // Excluir pipeline
  delete(id) {
    return apiClient.delete(`/pipelines/${id}`);
  },
  
  // Executar pipeline
  execute(id) {
    return apiClient.post(`/pipelines/${id}/execute`);
  }
};

// Serviço para gerenciamento de execuções
export const executionService = {
  // Obter todas as execuções
  getAll() {
    return apiClient.get('/executions');
  },
  
  // Obter execução por ID
  getById(id) {
    return apiClient.get(`/executions/${id}`);
  },
  
  // Obter logs de execução
  getLogs(id) {
    return apiClient.get(`/executions/${id}/logs`);
  },
  
  // Cancelar execução
  cancel(id) {
    return apiClient.post(`/executions/${id}/cancel`);
  }
};

// Serviço para gerenciamento de módulos
export const moduleService = {
  // Obter todos os módulos
  getAll() {
    return apiClient.get('/modules');
  },
  
  // Obter módulo por ID
  getById(id) {
    return apiClient.get(`/modules/${id}`);
  }
};
